import React from 'react';
import { Toolbar } from '@leverege/ui-plugin';
import { connect } from 'react-redux';
import { Flex } from '@leverege/ui-elements';
import { ToolbarContext } from '@leverege/ui-dashboard';
import ResponsiveView from "../responsive/ResponsiveView.js";
import S from './PieChartContainerView.css';
import { HeaderToolbar } from "../Util.js";
import { jsx as _jsx } from "react/jsx-runtime";
class PieChartContainerView extends React.Component {
  static contextType = ToolbarContext;
  getContext = dataViewerType => {
    return {
      client: PieChartContainerView.CLIENT,
      dataViewerType,
      clientProps: {
        ...this.props
      }
    };
  };
  rendererHeader = dataViewerModel => {
    if (dataViewerModel == null) {
      return null;
    }
    const {
      relationship: {
        path
      },
      objectType,
      inCard
    } = this.props;
    const actionBarMatchContext = {
      use: 'actionBar',
      client: PieChartContainerView.CLIENT,
      dataViewerType: dataViewerModel.type,
      objectType,
      path
    };
    const context = this.getContext(dataViewerModel.type);
    const content = /*#__PURE__*/_jsx(Flex, {
      className: inCard ? undefined : S.toolbars,
      variant: "tableToolbar",
      children: /*#__PURE__*/_jsx(Toolbar, {
        className: S.toolbar,
        variant: "actionBar",
        prefer: "icon",
        matchContext: actionBarMatchContext,
        context: context
      })
    });
    return /*#__PURE__*/_jsx(HeaderToolbar, {
      inCard: inCard,
      content: content
    });
  };
  render() {
    const {
      objectType
    } = this.props;
    const context = this.getContext(null);
    return /*#__PURE__*/_jsx(ResponsiveView, {
      ...this.props,
      objectType: objectType,
      context: context,
      paginator: this.paginator,
      useContentView: true,
      contentHeader: this.rendererHeader
    });
  }
}
export default connect((state, props) => {
  const {
    loading,
    paginator
  } = props;
  return {
    loading: loading && paginator.pageItems.length === 0
  };
})(PieChartContainerView);
PieChartContainerView.CLIENT = 'PieChartContainerView';